import { Empty } from 'ant-design-vue'
import type { FunctionalComponent } from 'vue'
import type { EmptyProps } from 'ant-design-vue'
const NsEmpty: FunctionalComponent<EmptyProps> = (props, { attrs, slots }) => {
  return <Empty {...props} {...attrs} v-slots={slots} tooltip-visible={false}></Empty>
}

export default NsEmpty
